import React from 'react';
import Docs from "./layout";
import Section from "./components/Section";
import Method from "./components/Method";
import Layout from "./layout";
import {Helmet} from "react-helmet";

const Introduction = ({type,children,location}) => {
    return (
        <Layout children={children} location={location}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>API Reference</title>
                <meta name="description" content="Shipping API for your website. Customize and automate your shipping to increase your customer experience. Easy to implement, connected to multiple carriers such as GRAB, Gojek, JNE, FedEx and more!" />
                <link rel="canonical" href="https://biteship.com/docs/api" />
            </Helmet>
            <div className="row">
                <div className="col-md-8">
                    <h1>Introduction </h1>
                    <br/>

                    <h2 className="h3">API Reference</h2>
                    <br/>
                    <p>
                        Biteship has a mission to help businesses to strive this digital era by bringing the most comprehensive logistics
                        infrastructure to the internet.
                    </p>
                    <p>
                        We hope by providing this API documentation can help you to create and make impact to the
                        society around you. So, let us know what we can help and let's shake the world together!
                    </p>
                </div>

            </div>
            <hr/>
            <div className="row">
                <div className="col-md-8">
                    <h2 className="h3">API Endpoint</h2>
                    <br/>
                    <p>
                        Biteship uses REST API to communicate between merchants and our supply chain channels.
                        All URLs referenced in the API documentation have the following base
                    </p>
                    <Method title={"BASE URL"}>
                        <p className="text-white-50">https://api.biteship.com </p>
                    </Method>
                </div>
            </div>
            <br/>
        </Layout>
    )
};

export default Introduction
